import type { SiteControllerSettingBaseFormModel } from "../../../../base/type";
import type { SiteControllerSettingAirHostFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
};

export const baseViewModelToViewModelConverter = ({ viewModel: _viewModel }: Props) => {
	const {
		isDirty,
		hasError, //
		hotelID,

		airHostSettings,
	} = _viewModel;

	const viewModel: SiteControllerSettingAirHostFormModel["ViewModel"] = {
		isDirty,
		hasError,

		hotelID,
		airHostSettings,
	};

	return { viewModel };
};
